import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App.jsx';
import { BASE_PATH } from './config.js';
import './styles/global.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {/*
      basename 必须和 site.basePath 一致。
      当前站点独占子域名根路径，BASE_PATH 是空串，所以不传、Router 用根路径。
      如果哪天改挂到子目录（比如 /web），浏览器地址会变成 /web/posts/1，
      而路由表里写的是 /posts/1 —— 少了 basename 就永远匹配不上，
      页面会直接落到「回首页」。
    */}
    <BrowserRouter basename={BASE_PATH || undefined}>
      <App />
    </BrowserRouter>
  </StrictMode>
);
